export default __webpack_public_path__ + "static/media/petri-dish-lb-amp-ara.b4189659.svg";